<template>
  <div>
    <main-scn
      :title="$t('modernSlavery.mainTitle')"
      :highlighted-word-index="2"
      image-url-path="footer-links/fundo-escravidao-moderna.jpg"
    />
    <scn>
      <section-header
        :title="$t('modernSlavery.introduction.title')"
        :subtitle="$t('modernSlavery.introduction.subtitle')"
      />
      <div class="scn__content container">
        <div class="two-col-content two-col-content--sm-l sm-l:items-center md:items-center">
          <div class="two-col-content__col mr-2 md:mr-0 md:px-5">
            <p v-for="paragraph in $t('modernSlavery.introduction.paragraphs')">
              {{ paragraph }}
            </p>
          </div>
          <div class="two-col-content__col mt-4 sm-l:mt-0 md:mt-0 md:pr-5">
            <img :src="$getImage('footer-links/juntos-somos-mais-fortes.svg')" :alt="`${$t('alt.logo')} Onesti`">
          </div>
        </div>
      </div>
    </scn>
    <scn color="grey">
      <section-header
        :title="$t('modernSlavery.ourBusiness.title')"
        :subtitle="$t('modernSlavery.ourBusiness.subtitle')"
      />
      <div class="scn__content container">
        <p v-for="paragraph in $t('modernSlavery.ourBusiness.paragraphs')" class="mb-2">
          {{ paragraph }}
        </p>
      </div>
    </scn>
    <scn>
      <section-header
        :title="$t('modernSlavery.ourPolitic.title')"
        :subtitle="$t('modernSlavery.ourPolitic.subtitle')"
      />

      <div class="scn__content container">
        <div class="two-col-content two-col-content--sm-l sm-l:items-center md:items-center">
          <div class="two-col-content__col sm-l:mr-3 md:mr-3 lg:px-3">
            <img :src="$getImage('footer-links/maos-acorrentadas.jpg')" :alt="`${$t('alt.logo')} Onesti`">
          </div>
          <div class="two-col-content__col mt-4 sm-l:mt-0 md:mt-0 lg:px-3">
            <p v-for="paragraph in $t('modernSlavery.ourPolitic.paragraphs')" class="mb-2">
              {{ paragraph }}
            </p>
          </div>
        </div>
      </div>
    </scn>
    <scn color="grey">
      <section-header
        :title="$t('modernSlavery.ourRelationships.title')"
        :subtitle="$t('modernSlavery.ourRelationships.subtitle')"
      />
      <div class="scn__content container">
        <p v-for="paragraph in $t('modernSlavery.ourRelationships.paragraphs')" class="mb-2">
          {{ paragraph }}
        </p>
      </div>
    </scn>
    <scn>
      <section-header
        :title="$t('modernSlavery.ourCommitment.title')"
        :subtitle="$t('modernSlavery.ourCommitment.subtitle')"
      />
      <div class="scn__content container">
        <p v-for="paragraph in $t('modernSlavery.ourCommitment.paragraphs')" class="mb-2">
          {{ paragraph }}
        </p>
        <download-button pdf-file-name="trabalho-escravo.pdf" />
      </div>
    </scn>
  </div>
</template>

<script>
import MainScn from '@/components/main-scn'
import DownloadButton from '@/components/download-button'

export default {
  name: 'ModernSlavery',
  components: {
    DownloadButton,
    MainScn
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.image-and-text-ctn
  @apply flex flex-col
  @screen sm-l
    @apply flex-row items-center
  @screen md
    @apply flex-row items-center
</style>
